import { PanelLeftClose } from "lucide-react";

import { RobotoCommunity, RobotoIconButton } from "@/shared/components";
import { useNavigationSidebar } from "@/shared/state/appSidebar";

import styles from "./AppNavigation.module.css";
import { Drawer } from "./Drawer";
import { Navigation } from "./Navigation";
import { OrgSettingsButton } from "./OrgSettings";
import { Sidebar } from "./Sidebar";

/**
 * Renders the App Navigation either as a sidebar
 * or a drawer depending on the screen size.
 */
export function AppNavigation() {
  const sidebar = useNavigationSidebar();

  return (
    <>
      {/* Sidebar for screens > md */}
      <Sidebar isOpen={sidebar.isSidebarOpen}>
        <nav className={styles.nav}>
          <header className={styles.header}>
            <OrgSettingsButton />
            <RobotoIconButton eventName="SidebarClosed" onClick={sidebar.close}>
              <PanelLeftClose className={styles.icon} />
            </RobotoIconButton>
          </header>
          <Navigation />
          <footer>
            <RobotoCommunity />
          </footer>
        </nav>
      </Sidebar>

      {/* Drawer for screens < md */}
      {!sidebar.isSidebarOpen && (
        <Drawer isOpen={sidebar.isDrawerOpen} onClose={sidebar.close}>
          <nav className={styles.nav}>
            <header className={styles.header}>
              <OrgSettingsButton />
            </header>
            <Navigation onNavigate={sidebar.close} />
            <footer>
              <RobotoCommunity />
            </footer>
          </nav>
        </Drawer>
      )}
    </>
  );
}
